import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppStore, TPanelSections } from '../../../../state/app.repository';
import { Chat } from '../../../../features/chat';
import { Spatial } from '../../../../features/spatial';
import { Video } from '../../../../features/video';
import { Whiteboard } from '../../../../features/whiteboard';
import { AppService } from '../../../services/app.service';
import { faArrowUpArrowDown } from '@fortawesome/pro-solid-svg-icons';
import { UserSettingsStore } from '../../../../state/user-settings.repository';

@Component({
  selector: 'andor-components-frame',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, Video, Whiteboard, Spatial, Chat],
  templateUrl: './components-frame.html',
  styleUrl: './components-frame.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComponentsFrame {
  protected readonly faArrowUpArrowDown = faArrowUpArrowDown;

  @Input() mode: 'pinned' | 'main' = 'main';
  @Input() component!: TPanelSections;

  // Accumulating rotation for the swap button. Each successful switch adds
  // 180° so the icon always spins forward and the CSS transition handles the
  // animation. Base is 90° to match the button's static orientation.
  protected readonly swapRotationDeg = signal(90);

  constructor(
    public appStore: AppStore,
    public appService: AppService,
    public userSettingsStore: UserSettingsStore
  ) {}

  pinComponent() {
    this.userSettingsStore.update({ panelClassPinned: this.component });
    if (this.component === 'video') {
      this.userSettingsStore.update({ panelClassMain: 'chat' });
    } else {
      this.userSettingsStore.update({ panelClassMain: 'video' });
    }
  }
  unpinComponent() {
    this.userSettingsStore.update({ panelClassPinned: null });
  }

  switchComponents() {
    if (this.mode === 'pinned') {
      this.userSettingsStore.store.update((state) => ({
        ...state,
        panelClassPinned: state.panelClassMain,
        panelClassMain: state.panelClassPinned ?? state.panelClassMain,
      }));
      this.swapRotationDeg.update((d) => d + 180);
    }
  }
}
